import { Box, Grid, IconButton } from '@material-ui/core'
import { mdiChevronLeft, mdiChevronRight } from '@mdi/js'
import Icon from '@mdi/react'
import { format } from 'date-fns'
import { ptBR } from 'date-fns/locale'
import React from 'react'

export const CalendarHeader = ({
  classes = {},
  calendarComponentRef,
  setDate = date => {},
  setView = view => {},
  date = new Date(),
  view = '',
}) => {
  const handleNextDay = () => {
    const calendarApi = calendarComponentRef.current.getApi()
    calendarApi.prev()

    const nextDate = new Date(calendarApi.getDate())
    setDate(nextDate)
  }

  const handlePrevDay = () => {
    const calendarApi = calendarComponentRef.current.getApi()
    calendarApi.next()

    const prevDate = new Date(calendarApi.getDate())
    setDate(prevDate)
  }

  const handleSetToday = () => {
    const dateToGo = new Date()
    setView('timeGridDay')
    setDate(dateToGo)

    const calendarApi = calendarComponentRef.current.getApi()
    calendarApi?.gotoDate(dateToGo)
  }

  return (
    <Grid container justifyContent="space-between">
      <Grid item xs container spacing={2}>
        <Grid item>
          <Box className={classes.calendarButtons}>
            <IconButton
              className={classes.calendarButton}
              onClick={handleNextDay}
            >
              <Icon path={mdiChevronLeft} size={1} />
            </IconButton>

            <IconButton
              className={classes.calendarButton}
              onClick={handlePrevDay}
            >
              <Icon path={mdiChevronRight} size={1} />
            </IconButton>
          </Box>
        </Grid>
        <Grid item>
          <IconButton className={classes.todayButton} onClick={handleSetToday}>
            Hoje
          </IconButton>
        </Grid>
      </Grid>

      <Grid item xs>
        <Box className={classes.calendarHeaderTitle}>
          {format(date, "iiii, dd 'de' MMMM 'de' yyyy", {
            locale: ptBR,
          })}
        </Box>
      </Grid>

      <Grid item xs container justifyContent="flex-end">
        <Box className={classes.periodButtons}>
          <IconButton
            className={[
              classes.periodButton,
              view == 'dayGridMonth' && classes.active,
            ]}
            onClick={() => setView('dayGridMonth')}
          >
            Mês
          </IconButton>

          <IconButton
            className={[
              classes.periodButton,
              view == 'timeGridWeek' && classes.active,
            ]}
            onClick={() => setView('timeGridWeek')}
          >
            Semana
          </IconButton>

          <IconButton
            className={[
              classes.periodButton,
              view == 'timeGridDay' && classes.active,
            ]}
            onClick={() => setView('timeGridDay')}
          >
            Dia
          </IconButton>
        </Box>
      </Grid>
    </Grid>
  )
}
